export default __webpack_public_path__ + "static/media/circle-regular.c2b62bd5.svg";